var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tabla',{attrs:{"telegrama":false,"acciones":true,"headers":_vm.headers,"data":_vm.mesas,"filtro":true,"procesar":true,"loading":_vm.fetchingData,"items-per-page":10},on:{"changed":_vm.changed}})}
var staticRenderFns = []

export { render, staticRenderFns }